import { Component } from '@angular/core';
import { LangI, LanguageService } from 'src/app/Core/services/language.service';

@Component({
  selector: 'app-lang-toggler',
  templateUrl: './lang-toggler.component.html',
  styleUrls: ['./lang-toggler.component.scss'],
})
export class LangTogglerComponent {
  constructor(private languageService: LanguageService) {}
  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }

  open() {
    let el = document.querySelector('.cet-lang-toggler');
    el?.classList.add('expanded');
  }

  get currentLangName() {
    return this.languageService.CurrentLang.Name == 'en' ? 'english' : 'عربي';
  }

  close() {
    setTimeout(() => {
      let el = document.querySelector('.cet-lang-toggler');
      el?.classList.remove('expanded');
    }, 180);
  }

  setArabic() {
    this.close();
    let arabic = this.languageService.LanguageList.find(
      (el) => el.Name == 'ar'
    );
    this.languageService.setLanguage(arabic as LangI);
  }

  setEnglish() {
    this.close();
    let english = this.languageService.LanguageList.find(
      (el) => el.Name == 'en'
    );
    this.languageService.setLanguage(english as LangI);
  }
}
